import React from "react";

import { useActionHook } from "hooks";
import { useDealActions } from "store";
import { Characteristic } from "store/types";

import { Form } from "./Form";

interface Props {
  onSuccess: (characteristic: Characteristic) => void;
  onCancel: () => void;
  data: Characteristic | null;
  /** "deal" (default) is omitted from the payload; "client" scopes the definition to the Client CRM. */
  entityType?: "deal" | "client";
}

export const Update: React.FC<Props> = ({ onSuccess, data, onCancel, entityType = "deal" }) => {
  const { updateCharacteristicAction } = useDealActions();

  const { loading, action } = useActionHook(updateCharacteristicAction, {
    onSuccess
  });

  return (
    <Form
      {...(data && {
        onSubmit: (values) =>
          action({ id: data.id, ...values, ...(entityType === "client" && { entity_type: "client" }) })
      })}
      onCancel={onCancel}
      isLoading={loading}
      initialState={data}
      entityType={entityType}
    />
  );
};
